<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\changeLanguageManual-1.png" alt="" /></div>
                <div>
                    <p>画面上部のメインメニューバーにある「国旗アイコン」をクリックし、表示された国旗（言語）リストから1つを選択します。</p>
                    <p>※国旗と言語の対応関係は以下の通りです。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changeLanguageManual-2.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/changeLanguage_manual.vue